<template>
  <div class="bg-grey-lighten-5 min-h-screen">
    
    <!-- Barra Superior Moderna -->
    <v-card rounded="0" elevation="0" class="bg-white border-b sticky-top z-index-100">
      <v-container fluid class="d-flex justify-space-between align-center py-2 py-md-3 px-3 px-md-6">
        
        <!-- Título y Breadcrumb implícito -->
        <div class="d-flex align-center">
          <!-- Ícono más pequeño en móvil -->
          <div class="mr-2 mr-md-4 rounded-lg bg-indigo-lighten-5 d-flex align-center justify-center" 
               :style="$vuetify.display.smAndDown ? 'width: 32px; height: 32px;' : 'width: 40px; height: 40px;'">
            <v-icon :style="$vuetify.display.smAndDown ? 'font-size: 14px; color: #283593;' : 'font-size: 18px; color: #283593;'">
              fa:fa-solid fa-ticket
            </v-icon>
          </div>
          <div>
            <!-- Título más pequeño en móvil -->
            <h1 class="font-weight-black text-grey-darken-3 mb-0" 
                :class="$vuetify.display.smAndDown ? 'text-subtitle-1' : 'text-h6'" 
                style="line-height: 1;">
              Tickets
            </h1>
            <!-- Subtítulo oculto en móvil -->
            <div v-if="$vuetify.display.mdAndUp" class="text-caption text-medium-emphasis font-weight-medium">
              Gestiona tus solicitudes de diseño
            </div>
          </div>
        </div>

        <!-- Acciones -->
        <div class="d-flex align-center gap-2">
          
          <!-- Filtros Desktop -->
          <v-btn v-if="$vuetify.display.mdAndUp" @click="hidefilters = !hidefilters" 
            variant="text" color="grey-darken-2" class="text-caption font-weight-bold" 
            :class="{'bg-grey-lighten-4': !hidefilters}">
            <template v-slot:prepend>
              <i class="fa-solid fa-filter mr-2" style="font-size: 14px;"></i>
            </template>
            Filtros
          </v-btn>

          <!-- Exportar Desktop -->
          <v-btn v-if="$vuetify.display.mdAndUp" @click="exportarTicketsAxios()" 
            variant="text" color="grey-darken-2" class="text-caption font-weight-bold">
            <template v-slot:prepend>
              <i class="fa-solid fa-download mr-2" style="font-size: 14px;"></i>
            </template>
            Exportar
          </v-btn>

          <!-- Filtros Móvil -->
          <v-btn v-if="$vuetify.display.smAndDown" @click="openFiltroMobil()" 
            icon size="small" variant="text" color="grey-darken-2">
            <i class="fa-solid fa-filter" style="font-size: 14px;"></i>
          </v-btn>

          <!-- Exportar Móvil -->
          <v-btn v-if="$vuetify.display.smAndDown" @click="exportarTicketsAxios()" 
            icon size="small" variant="text" color="grey-darken-2">
            <i class="fa-solid fa-download" style="font-size: 14px;"></i>
          </v-btn>

          <v-divider v-if="$vuetify.display.mdAndUp" vertical class="mx-2 my-1"></v-divider>

          <!-- Nuevo Ticket Desktop (con texto) -->
          <v-btn v-if="$vuetify.display.mdAndUp" :to="{ name: 'nuevoticket' }" 
            rounded="lg" elevation="4" color="primary" class="px-6 font-weight-bold"
            style="background: linear-gradient(135deg, #002B49 0%, #005691 100%);">
            <template v-slot:prepend>
              <i class="fa-solid fa-plus mr-2 text-white" style="font-size: 14px;"></i>
            </template>
            Nuevo Ticket
          </v-btn>

          <!-- Nuevo Ticket Móvil (solo ícono) -->
          <v-btn v-if="$vuetify.display.smAndDown" :to="{ name: 'nuevoticket' }" 
            icon elevation="4" color="primary" size="default"
            style="background: linear-gradient(135deg, #002B49 0%, #005691 100%);">
            <i class="fa-solid fa-plus text-white" style="font-size: 16px;"></i>
          </v-btn>

        </div>
      </v-container>
    </v-card>

    <!-- Contenido Principal -->
    <v-container fluid class="px-4 px-md-8 py-6">
      <v-row>
        <!-- Lista de Tickets -->
        <v-col cols="12" :md="hidefilters ? '12' : '9'" :xl="hidefilters ? '12' : '10'" class="transition-all">
          <div class="bg-white rounded-xl border shadow-sm overflow-hidden h-100">
            <ListTickets :tickets="listTickets" :visitor="isRoleVisitor()"/>
          </div>
        </v-col>

        <!-- Sidebar Filtros -->
        <v-col v-if="!hidefilters && $vuetify.display.mdAndUp" cols="12" md="3" xl="2" class="transition-all">
          <div class="sticky-sidebar">
            <div class="bg-white rounded-xl border shadow-sm pa-4">
              <div class="d-flex align-center justify-space-between mb-4">
                <span class="text-caption font-weight-bold text-uppercase text-medium-emphasis ls-1">Filtrar por</span>
                <v-btn icon density="compact" variant="text" color="grey-lighten-1" @click="hidefilters = true">
                  <i class="fa-solid fa-xmark" style="font-size: 14px;"></i>
                </v-btn>
              </div>
              <FiltrosTicketsComponent :visitor="isRoleVisitor()"></FiltrosTicketsComponent>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>
 
<script>
import { shallowRef } from 'vue';
import FiltrosTicketsComponent from "../components/FiltrosTicketsComponent.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import ListTickets from "../components/ListTickets.vue";
import Filters from '@/modules/Shared/Filters';
export default {
  mixins: [Filters],
  components: {
    ListTickets,
    FiltrosTicketsComponent,
  },

  data() {
    return {
      hidefilters: false
    };
  },

  computed: {
    ...mapState("tickets", ["listTickets"]),
    ...mapState("agentes", ["listaAgentes"])
  },

  methods: {

    ...mapActions("agentes", ['getAgentesAxios']),
    ...mapActions("tickets", ['exportarTicketsAxios']),
    ...mapMutations(["changeSilderMulti", "changeComponentDynamic"]),
    ...mapMutations('answers', ['resetListAnswers']),

    openFiltroMobil()
    {
      const  component= shallowRef(FiltrosTicketsComponent)
      this.changeSilderMulti()
      this.changeComponentDynamic({componentName: component, props:{ class: "pa-5"}})
    },

  },

  mounted() {

    this.resetListAnswers()
  }
};
</script>

<style scoped>
.min-h-screen {
  min-height: 100vh;
}

.sticky-top {
  position: sticky;
  top: 64px; /* Ajuste para navbar */
  z-index: 90;
}

.sticky-sidebar {
  position: sticky;
  top: 140px; 
}

.gap-2 {
  gap: 8px;
}

.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

.transition-all {
  transition: all 0.3s ease;
}

.ls-1 {
  letter-spacing: 1px;
}
</style>